import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
		path: "/",
		redirect: "/main",
	},
	{
		path: '/main',
		name: 'main',
		component: () => import('../views/main/index.vue'),
		redirect: {
			name: "index"
		},
		children: [{
				path: "/index",
				name: 'index',
				component: () => import("../views/index/index.vue"),
				meta: {
					name: "首页"
				}
			},
			{
				path: "/housing",
				name: 'housing',
				component: () => import("../views/housing/index.vue"),
				meta: {
					name: "房源分布"
				}
			},
			{
				path: "/journalism",
				name: 'journalism',
				component: () => import("../views/journalism/index.vue"),
				meta: {
					name: "新闻中心"
				}
			},
			{
				path: "/new-details",
				name: 'new-details',
				component: () => import("../views/new-details/index.vue"),
				meta: {
					name: "新闻详情"
				}
			},
			{
				path: "/check",
				name: 'check',
				component: () => import("../views/check/index.vue"),
				meta: {
					name: "入住须知"
				}
			},
			{
				path: "/service",
				name: 'service',
				component: () => import("../views/service/index.vue"),
				meta: {
					name: "服务中心"
				}
			},
			{
				path: "/room-details",
				name: 'room-details',
				component: () => import("../views/room-details/index.vue"),
				meta: {
					name: "房源分布详情"
				}
			},
			{
				path: "/login",
				name: 'login',
				component: () => import("../views/login/index.vue"),
				meta: {
					name: "登录"
				}
			},
			{
				path: "/register",
				name: 'register',
				component: () => import("../views/register/index.vue"),
				meta: {
					name: "注册"
				}
			},
			{
				path: "/forget",
				name: 'forget',
				component: () => import("../views/forget/index.vue"),
				meta: {
					name: "忘记密码"
				}
			},
			{
				path: "/introduce",
				name: 'introduce',
				component: () => import("../views/introduce/index.vue"),
				meta: {
					name: "门店介绍"
				}
			},
			{
				path: "/about",
				name: 'about',
				component: () => import("../views/about/index.vue"),
				meta: {
					name: "关于我们"
				}
			},
			{
				path: "/contact",
				name: 'contact',
				component: () => import("../views/contact/index.vue"),
				meta: {
					name: "联系我们"
				}
			},
			{
				path: "/personal",
				name: 'personal',
				component: () => import("../views/personal/index.vue"),
				meta: {
					name: "个人中心"
				}
			},
		]
	},
	{
		path: '/pageNotFound',
		name: 'pageNotFound',
		component: () => import("@/views/page-not-found/index.vue")
	},
	{
		path: '*', // 页面不存在的情况下会跳到404页面
		redirect: '/pageNotFound',
		name: 'notFound',
		hidden: true
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}

export default router
